export default __webpack_public_path__ + "static/assets/med_pill_square_in_L2_solid_x_01_f.933d5a92.png";